import { connect } from "react-redux";
import OrderListButtonGroup from "../components/OrderListButtonGroup";

export default connect(
  null,
  null
)(OrderListButtonGroup);
